export  const themePattern = {
    mobile:{
        // Colors
        color1 : "#138770",
        color2 : "rgba(26, 188, 156, 0.2)",
        scolor2 : "#04362c",
        color3: "#4EDEC1",
        white: "#fff",
        black: "#000",
        gray: "#4B5755",
        bege: "#fefcfe",

        // Headers
        title1:36,
        title2:28,
        title3:20,
        par1:16,
        par2:14,
        par3:12,


        // Spacing 
        retreat: 15,

        // Radius
    },
    tablet:{
        // Colors
        color1 : "#138770",
        color2 : "rgba(26, 188, 156, 0.2)",
        scolor2 : "#04362c",
        color3: "#4EDEC1",
        white: "#fff",
        black: "#000",
        gray: "#4B5755",
        bege: "#fefcfe",

        // Headers
        title1:42,
        title2:32,
        title3:22,
        par1:20,
        par2:18,
        par3:14,


        // Spacing 
        retreat: 15

        // Radius
    },
    desktop:{
        // Colors
        color1 : "#138770",
        color2 : "rgba(26, 188, 156, 0.2)",
        scolor2 : "#04362c",
        color3: "#4EDEC1",
        white: "#fff",
        black: "#000",
        gray: "#4B5755",
        bege: "#fefcfe",

        // Headers
        title1:48,
        title2:36,
        title3:24,
        par1:22,
        par2:20,
        par3:18,


        // Spacing 
        retreat: 15,
        retreatFull: "10rem",
        retreatDesketop: 'auto'

        // Radius
    },
    breakpoint:{
        mobile: 768
    }
};
